import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_KIND,
  DELETE_KIND,
  GET_KINDS,
  UPDATE_KIND,
  UPDATE_KIND_STATUS
} from "./actionTypes";

import {
  addKindFail,
  addKindSuccess,
  deleteKindFail,
  deleteKindSuccess,
  getKindsFail,
  getKindsSuccess,
  setState,
  updateKindFail,
  updateKindSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { kinds, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchKinds({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, kinds, params.toString());
    yield put(setState(false));
    yield put(getKindsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getKindsFail(error));
  }
}

function* updateKind({ payload: kindObj }) {
  try {
    const { id, recordStatus, ...rest } = kindObj;
    yield call(patchApiCall, `${kinds}/${id}`, rest);
    const response = yield call(getTable, `${kinds}/${kindObj.id}`);
    toast.success('Registro actualizado correctamente');
    yield put(updateKindSuccess(response));
  } catch (error) {
    toast.error('Error al actualizar el registro');
    yield put(updateKindFail(error));
  }
}

function* updateKindStatus({ payload: kindObj }) {
  try {
    const { id } = kindObj;
    yield call(patchApiCall, `${kinds}/${updateStatus}/${id}`, { recordStatus: kindObj.recordStatus });
    const response = yield call(getTable, `${kinds}/${kindObj.id}`);
    yield put(updateKindSuccess(response));
  } catch (error) {
    yield put(updateKindFail(error));
  }
}

function* deleteKind({ payload: kindObj }) {
  try {
    yield call(deleteApiCall, `${kinds}/${kindObj.id}`);
    yield put(deleteKindSuccess(kindObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    toast.error('Error al borrar el registro');
    yield put(deleteKindFail(error));
  }
}

function* postingKind({ payload: kind }) {
  try {
    const response = yield call(postApiCall, kinds, kind);
    yield put(addKindSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    toast.error('Error al agregar el registro');
    yield put(addKindFail(error));
  }
}

function* kindsSaga() {
  yield takeEvery(GET_KINDS, fetchKinds);
  yield takeEvery(ADD_NEW_KIND, postingKind);
  yield takeEvery(UPDATE_KIND, updateKind);
  yield takeEvery(UPDATE_KIND_STATUS, updateKindStatus);
  yield takeEvery(DELETE_KIND, deleteKind);
}

export default kindsSaga;
